export const getIsSuccessStatus = (status: number) => {
  const regexForSuccessResponse = /^2\d\d$/;

  return regexForSuccessResponse.test(status.toString())
}